import { atom } from "recoil";

export const txHashAtom = atom({
  key: "txHash",
  default: "",
});
